import { useStoreMap } from 'effector-react'
import { useEffect } from 'react'
import { useEvent, useStore } from 'effector-react/compat'
import { $searchTerm } from 'src/features/goods-groups-update/model'
import { deleteHistorySuggestion } from 'src/features/suggestions/history'
import { $paginationGoods } from 'src/widgets/pagination-goods/model'

export function useRemoveSuggestion() {
    const goodsCount = useStoreMap($paginationGoods, (state) => state.length)
    const searchTerm = useStore($searchTerm)
    const deleteSuggestion = useEvent(deleteHistorySuggestion)

    useEffect(() => {
        if (!goodsCount) {
            deleteSuggestion(searchTerm)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm])
}
